/**
 * 管理后台用户接口
 * 管理后台用户接口API
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The AccountDailyRiskStatVo model module.
   * @module account_mgt/model/AccountDailyRiskStatVo
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>AccountDailyRiskStatVo</code>.
   * @alias module:account_mgt/model/AccountDailyRiskStatVo
   * @class
   */
  var exports = function() {
    var _this = this;


















  };

  /**
   * Constructs a <code>AccountDailyRiskStatVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:account_mgt/model/AccountDailyRiskStatVo} obj Optional instance to populate.
   * @return {module:account_mgt/model/AccountDailyRiskStatVo} The populated <code>AccountDailyRiskStatVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'totalRows')) {
        obj['totalRows'] = ApiClient.convertToType(data['totalRows'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'ipCount')) {
        obj['ipCount'] = ApiClient.convertToType(data['ipCount'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'riskRows')) {
        obj['riskRows'] = ApiClient.convertToType(data['riskRows'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'totalCostTimeMs')) {
        obj['totalCostTimeMs'] = ApiClient.convertToType(data['totalCostTimeMs'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'cntOverMaxCostTime')) {
        obj['cntOverMaxCostTime'] = ApiClient.convertToType(data['cntOverMaxCostTime'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'cntExitBeforeEnter')) {
        obj['cntExitBeforeEnter'] = ApiClient.convertToType(data['cntExitBeforeEnter'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'cntCostTimeMismatch')) {
        obj['cntCostTimeMismatch'] = ApiClient.convertToType(data['cntCostTimeMismatch'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'cntDrillType0Effective0')) {
        obj['cntDrillType0Effective0'] = ApiClient.convertToType(data['cntDrillType0Effective0'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'cntEnterTimeLt1s')) {
        obj['cntEnterTimeLt1s'] = ApiClient.convertToType(data['cntEnterTimeLt1s'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'cntExitTimeLt1s')) {
        obj['cntExitTimeLt1s'] = ApiClient.convertToType(data['cntExitTimeLt1s'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'cntDbOverlap')) {
        obj['cntDbOverlap'] = ApiClient.convertToType(data['cntDbOverlap'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'cntRateAccountMin')) {
        obj['cntRateAccountMin'] = ApiClient.convertToType(data['cntRateAccountMin'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'maxRateAccountMin')) {
        obj['maxRateAccountMin'] = ApiClient.convertToType(data['maxRateAccountMin'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'maxEnterSameSecRows')) {
        obj['maxEnterSameSecRows'] = ApiClient.convertToType(data['maxEnterSameSecRows'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'maxExitSameSecRows')) {
        obj['maxExitSameSecRows'] = ApiClient.convertToType(data['maxExitSameSecRows'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'cntRateIpMin')) {
        obj['cntRateIpMin'] = ApiClient.convertToType(data['cntRateIpMin'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'maxRateIpMin')) {
        obj['maxRateIpMin'] = ApiClient.convertToType(data['maxRateIpMin'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * 该账号总记录数
   * @member {Integer} totalRows
   */
  exports.prototype['totalRows'] = undefined;
  /**
   * 该账号涉及的IP数量
   * @member {Integer} ipCount
   */
  exports.prototype['ipCount'] = undefined;
  /**
   * 命中任一风控规则的记录数
   * @member {Integer} riskRows
   */
  exports.prototype['riskRows'] = undefined;
  /**
   * 当日全部学习记录累计耗时（毫秒）
   * @member {Integer} totalCostTimeMs
   */
  exports.prototype['totalCostTimeMs'] = undefined;
  /**
   * 命中单条耗时超上限次数
   * @member {Integer} cntOverMaxCostTime
   */
  exports.prototype['cntOverMaxCostTime'] = undefined;
  /**
   * 命中退出早于进入次数
   * @member {Integer} cntExitBeforeEnter
   */
  exports.prototype['cntExitBeforeEnter'] = undefined;
  /**
   * 命中区间时长小于上报耗时次数
   * @member {Integer} cntCostTimeMismatch
   */
  exports.prototype['cntCostTimeMismatch'] = undefined;
  /**
   * 命中签名不合法调用次数
   * @member {Integer} cntDrillType0Effective0
   */
  exports.prototype['cntDrillType0Effective0'] = undefined;
  /**
   * 命中同账号多条阅读记录进入时间差小于1秒次数
   * @member {Integer} cntEnterTimeLt1s
   */
  exports.prototype['cntEnterTimeLt1s'] = undefined;
  /**
   * 命中同账号多条阅读记录退出时间差小于1秒次数
   * @member {Integer} cntExitTimeLt1s
   */
  exports.prototype['cntExitTimeLt1s'] = undefined;
  /**
   * 命中重叠组耗时总和超并集区间长度次数
   * @member {Integer} cntDbOverlap
   */
  exports.prototype['cntDbOverlap'] = undefined;
  /**
   * 命中账号分钟频率超阈值次数
   * @member {Integer} cntRateAccountMin
   */
  exports.prototype['cntRateAccountMin'] = undefined;
  /**
   * 账号分钟提交频率最高值
   * @member {Integer} maxRateAccountMin
   */
  exports.prototype['maxRateAccountMin'] = undefined;
  /**
   * 同一秒进入最大记录条数
   * @member {Integer} maxEnterSameSecRows
   */
  exports.prototype['maxEnterSameSecRows'] = undefined;
  /**
   * 同一秒退出最大记录条数
   * @member {Integer} maxExitSameSecRows
   */
  exports.prototype['maxExitSameSecRows'] = undefined;
  /**
   * 命中IP分钟频率超阈值次数
   * @member {Integer} cntRateIpMin
   */
  exports.prototype['cntRateIpMin'] = undefined;
  /**
   * IP分钟提交频率最高值
   * @member {Integer} maxRateIpMin
   */
  exports.prototype['maxRateIpMin'] = undefined;



  export default exports;
;


